import React, {useEffect, useState} from 'react';
import {useDispatch} from "react-redux";
import careersActions from "../../store/actions/careers";
import agentsActions from "../../store/actions/agents";
import {Link, useNavigate} from "react-router-dom";
import axios from "axios";
import {logDOM} from "@testing-library/react";

const JobItem = (props) => {
    const {job} = props;
    const {number} = props;
    const dispatch = useDispatch();
    const [open, setOpen] = useState(false);
    let navigate = useNavigate();

    const openJobInfo = (id) => {
        dispatch(careersActions.setJob(null));
        navigate(`/careers/${id}`, {
            state : "information"
        })
    }

    const toggleItem = (target) => {
        if (!target.classList.contains('job-item__button')) {
            if (open) {
                setOpen(false)
            } else {
                setOpen(true);
            }
        }
    }

    const applyJob = (position) => {
        dispatch(careersActions.setFormJobPosition(position));
        dispatch(careersActions.setModalOpen(true));
        document.getElementsByTagName('body')[0].classList.add('modal-open');
    }

    return (
        <div className={`job-item ${open ? 'open' : 'closed'}`}>
            <button type="button" className="job-item__heading" onClick={(e) => toggleItem(e.target)}>
                <div className="job-item__arrow">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M7.41 8L12 12.9447L16.59 8L18 9.52227L12 16L6 9.52227L7.41 8Z" fill="#727683"/>
                    </svg>
                </div>
                <div className="job-item__title">{job.position}</div>
                <div className="job-item__location">{job.location}</div>
                <div className="job-item__format">{job.employmentType.name}</div>
                { job.url ? (
                    <a href={job.url} target="_blank" className="job-item__button button-blue">Apply now</a>
                ) : (
                    <div className="job-item__button button-blue" onClick={() => applyJob(job.position)}>Apply now</div>
                )}
            </button>
            <div className="job-item__body">
                <div className="job-item__body-content">
                    <div className="job-item__format-mobile">{job.employmentType.name}</div>
                    <div className="job-item__location-mobile">{job.location}</div>
                    <div className="job-item__description" dangerouslySetInnerHTML={{__html: job.summary}}/>
                    {/*<div className="job-item__requirements" dangerouslySetInnerHTML={{__html: job.requirements}}/>*/}
                    <button
                        className='job-item__link'
                        onClick={() => openJobInfo(job.id)}
                    >
                        <span>Read more</span>
                        <img src={`${process.env.REACT_APP_MY_API_KEY}rvos-graphics/assets/img/icons/arrow-right.svg`} alt="arrow"/>
                    </button>
                </div>
            </div>
        </div>
    );
};

export default JobItem;
